// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bo-core/grids/FunctionalitiesGrid/components/uiRotesAndEndpointsModal/assignedEndpoints.css
// module id = 768
// module chunks = 1